import React from "react";
import bg26 from "../../assets/images/background/bg-26.png";
import mainchef from "../../assets/images/resource/managements/md.png";
import coo from "../../assets/images/resource/managements/coo.png";
import signature from "../../assets/images/resource/signature-2.png";

function Chefsection() {
  return (
    <>
      <section className="chef-section">
        <div className="right-bg">
          <img src={bg26} alt="" title="" />
        </div>
        <div className="auto-container">
          <div className="row clearfix">
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div
                className="inner wow fadeInLeft"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div className="image">
                  <img src={mainchef} alt="" />
                </div>
              </div>
            </div>

            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div
                className="inner clearfix wow fadeInRight"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div class="content-box">
                  <div class="title-box">
                    <div class="subtitle">
                      <span>Chairman and MD</span>
                    </div>
                    <div class="pattern-image">
                      <img
                        src={
                          require("../../assets/images/icons/separator.svg")
                            .default
                        }
                        alt=""
                        title=""
                      />
                    </div>
                    <h2>Jashim Uddin Ahmed</h2>
                    <div class="text">
                      Welcome to the web presence of X-group Chain Restaurant
                      and thank you for taking interest to visit our website.
                      This website will give you an insight into our group. We
                      do everything with respect to our corporate values;
                      Honesty, Courage, Achievement, Respect, Responsibility,
                      Care, Dedication, Integrity and Transparency. We follow
                      these values every day to maintain our business
                      relationship. We ensure to deliver quality food at a
                      reasonable price and serve my people with extra care and
                      attention. Hence our slogan; Price Quality Service.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="chef-section">
        <div className="right-bg">
          <img src={bg26} alt="" title="" />
        </div>
        <div className="auto-container">
          <div className="row clearfix">
            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div
                className="inner clearfix wow fadeInRight"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div class="content-box">
                  <div class="title-box">
                    <div class="subtitle">
                      <span>Chief Operating Officer</span>
                    </div>
                    <div class="pattern-image">
                      <img
                        src={
                          require("../../assets/images/icons/separator.svg")
                            .default
                        }
                        alt=""
                        title=""
                      />
                    </div>
                    <h2>Mohammad Jahangir Alam</h2>
                    <div class="text">
                      On behalf of the Corporate Management team of X-group
                      Chain Restaurant, I have the pleasure to welcome you all
                      to visit our website. We have a long standing reputation
                      for excellent customer services. We continually seek
                      innovative and creative ways to meet the needs of our
                      guests. I’m proud that we are recognized for our
                      commitment to our customers and associates. We obtained
                      “valuable guests” ranked through customer’s questionnaire
                      from Dhaka’s most admired companies. We invite you to
                      visit our restaurants and we will provide you quality food
                      and great services. Wherever you visit, we’ll be there to
                      welcome you at one of our many exciting branches around
                      the Dhaka city. Wishing you awesome visit experiences
                      wherever you go!
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div
                className="inner wow fadeInLeft"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div className="image">
                  <img src={coo} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Chefsection;
